import { useState } from 'react'

import Button from '../../Button'
import { FilesPreviewGallery as FilesPreviewGalleryComponent } from '../../FilesPreviewGallery'
import { Container } from '../Container'

import { FILES } from './FilesPreviewGallery.mock'

function FilesPreviewGallery() {
  const [activeFileIndex, setActiveFileIndex] = useState(null)

  return (
    <Container label='FilesPreviewGallery'>
      <Button.Text
        height='24'
        text='Click for preview'
        onClick={() => setActiveFileIndex(0)}
      />
      <FilesPreviewGalleryComponent
        files={FILES}
        initActive={activeFileIndex}
        onClose={() => setActiveFileIndex(null)}
      />
    </Container>
  )
}

export default FilesPreviewGallery
